import React from 'react';

type ChangeHandler = (name: string, value: unknown) => void;
type ChangeEvent = React.ChangeEvent<{ name?: string; value: unknown }> | { target: { value: unknown; name?: string } };

export class InputOnChangeNormalizer {
    private readonly handleChange: ChangeHandler;

    public constructor(onChange: ChangeHandler) {
        this.handleChange = onChange;
    }

    public get onChange(): (evt: ChangeEvent) => void {
        return this.onChangeEvtHandler.bind(this);
    }

    public get onCheckboxChange(): (evt: ChangeEvent, checked: boolean) => void {
        return this.onCheckedEvtHandler.bind(this);
    }

    public onChangeEvtHandler(evt: ChangeEvent): void {
        if (!evt.target.name) {
            throw new Error('Control must have name defined');
        }

        this.handleChange(evt.target.name, evt.target.value);
    }

    public onCheckedEvtHandler(evt: ChangeEvent, checked: boolean): void {
        if (!evt.target.name) {
            throw new Error('Control must have name defined');
        }

        this.handleChange(evt.target.name, checked);
    }

    public updateValue(name: string, value: unknown): void {
        this.handleChange(name, value);
    }
}
